import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@mui/material';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import Button from '@/components/ui/Button/Button';
import type { DocumentationModalProps } from './IDocumentationModal';

const markdownComponents = {
    table: ({ children }: { children?: React.ReactNode }) => (
        <Table sx={{ mb: 2, border: 1, borderColor: 'divider' }}>{children}</Table>
    ),
    thead: ({ children }: { children?: React.ReactNode }) => <TableHead>{children}</TableHead>,
    tbody: ({ children }: { children?: React.ReactNode }) => <TableBody>{children}</TableBody>,
    tr: ({ children }: { children?: React.ReactNode }) => <TableRow>{children}</TableRow>,
    th: ({ children }: { children?: React.ReactNode }) => (
        <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'action.hover' }}>
            {children}
        </TableCell>
    ),
    td: ({ children }: { children?: React.ReactNode }) => <TableCell>{children}</TableCell>,
};

const DocumentationModal = ({ open, content, onClose }: DocumentationModalProps) => (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>Pricebook Rule Ranking Guide</DialogTitle>
        <DialogContent>
            <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
                {content}
            </ReactMarkdown>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose}>Close</Button>
        </DialogActions>
    </Dialog>
);

export default DocumentationModal;
